import { render, staticRenderFns } from "./TftRankTable.vue?vue&type=template&id=91fd5c86&"
import script from "./TftRankTable.vue?vue&type=script&lang=js&"
export * from "./TftRankTable.vue?vue&type=script&lang=js&"
import style0 from "./TftRankTable.vue?vue&type=style&index=0&id=91fd5c86&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports